import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const getToken = () => localStorage.getItem("token");

export const FETCH_JOBS_REQUEST = "FETCH_JOBS_REQUEST";
export const FETCH_JOBS_SUCCESS = "FETCH_JOBS_SUCCESS";
export const FETCH_JOBS_FAILURE = "FETCH_JOBS_FAILURE";

export const CREATE_JOB_REQUEST = "CREATE_JOB_REQUEST";
export const CREATE_JOB_SUCCESS = "CREATE_JOB_SUCCESS";
export const CREATE_JOB_FAILURE = "CREATE_JOB_FAILURE";

export const UPDATE_JOB_REQUEST = "UPDATE_JOB_REQUEST";
export const UPDATE_JOB_SUCCESS = "UPDATE_JOB_SUCCESS";
export const UPDATE_JOB_FAILURE = "UPDATE_JOB_FAILURE";

export const DELETE_JOB_REQUEST = "DELETE_JOB_REQUEST";
export const DELETE_JOB_SUCCESS = "DELETE_JOB_SUCCESS";
export const DELETE_JOB_FAILURE = "DELETE_JOB_FAILURE";

/* ================= FETCH JOBS ================= */
export const fetchJobs = () => async (dispatch) => {
  dispatch({ type: FETCH_JOBS_REQUEST });
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/jobPosts`, {
      headers: { Authorization: getToken() },
    });
    dispatch({
      type: FETCH_JOBS_SUCCESS,
      payload: response.data?.data || [],
    });
  } catch (error) {
    const errorMsg = error.response?.data?.message || "Failed to fetch jobs";
    dispatch({ type: FETCH_JOBS_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
  }
};

/* ================= CREATE JOB ================= */
export const createJob = (jobData) => async (dispatch) => {
  dispatch({ type: CREATE_JOB_REQUEST });
  try {
    const response = await axios.post(`${BASE_URL}/v1/api/admin/createJobPost`, jobData, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: CREATE_JOB_SUCCESS, payload: response.data?.data });
    toast.success("Job post created successfully");
    dispatch(fetchJobs()); // Refresh list
    return true;
  } catch (error) {
    const errorMsg = error.response?.data?.message || "Create failed";
    dispatch({ type: CREATE_JOB_FAILURE, payload: errorMsg });
    toast.error(errorMsg);
    return false;
  }
};

/* ================= UPDATE JOB ================= */
export const updateJob = (id, jobData) => async (dispatch) => {
  dispatch({ type: UPDATE_JOB_REQUEST });
  try {
    const response = await axios.put(`${BASE_URL}/v1/api/admin/updateJobPost/${id}`, jobData, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: UPDATE_JOB_SUCCESS, payload: response.data?.data });
    toast.success("Job post updated successfully");
    dispatch(fetchJobs());
    return true;
  } catch (error) {
    const errorMsg = error.response?.data?.message || "Update failed";
    dispatch({ type: UPDATE_JOB_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
    return false;
  }
};

/* ================= DELETE JOB ================= */
export const deleteJob = (id) => async (dispatch) => {
  dispatch({ type: DELETE_JOB_REQUEST });
  try {
    await axios.delete(`${BASE_URL}/v1/api/admin/deleteJobPost/${id}`, {
      headers: { Authorization: getToken() },
    });
    dispatch({ type: DELETE_JOB_SUCCESS, payload: id });
    toast.success("Job post deleted successfully");
  } catch (error) {
    const errorMsg = error.response?.data?.message || "Delete failed";
    dispatch({ type: DELETE_JOB_FAILURE, payload: String(errorMsg) });
    toast.error(String(errorMsg));
  }
};